import { render, staticRenderFns } from "./Bets.vue?vue&type=template&id=a9a1c352&scoped=true&"
import script from "./Bets.vue?vue&type=script&lang=js&"
export * from "./Bets.vue?vue&type=script&lang=js&"
import style0 from "./Bets.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Bets.vue?vue&type=style&index=1&id=a9a1c352&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a1c352",
  null
  
)

export default component.exports